import React, { useState, useCallback } from 'react';
import {
  Box,
  Paper,
  Typography,
  Alert,
  CircularProgress
} from '@mui/material';
import AppleLogin from 'react-apple-login';
import { adminLoginWithApple } from '../helpers/api';

function LoginPage({ onLogin }) {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAppleSuccess = useCallback(async (data) => {
    console.log('Apple login success:', data);
    setLoading(true);
    setError('');

    try {
      let appleName = null;

      // Get name from user object if available
      if (data?.user) {
        appleName = data.user.name?.firstName ?
          `${data.user.name.firstName} ${data.user.name.lastName || ''}`.trim() :
          data.user.name || null;
      }

      const idToken = data?.authorization?.id_token;

      if (!idToken) {
        setError('Nao foi possivel identificar usuario');
        setLoading(false);
        return;
      }

      // Call API to verify admin access and get JWT
      const result = await adminLoginWithApple(idToken, appleName);
      console.log('Login API result:', result);
      onLogin(result);
      console.log('Called onLogin callback');
    } catch (err) {
      console.error('Admin login failed:', err);
      // Check if it's a pending approval error
      if (err.message?.includes('pending_approval') || err.message?.includes('aguardando aprovação')) {
        setError('✅ Conta criada! Aguarde a aprovação do administrador para acessar o sistema.');
      } else {
        setError(err.message || 'Acesso negado');
      }
    } finally {
      setLoading(false);
    }
  }, [onLogin]);

  const handleAppleError = useCallback((err) => {
    console.error('Apple login error:', err);

    // Don't show error for user cancellation or popup events
    if (
      err === 'popup_closed_by_user' ||
      err?.error === 'popup_closed_by_user' ||
      err === 'popup_opened' ||
      err?.error === 'popup_opened'
    ) {
      console.log('User interaction with popup, not an error');
      return;
    }

    setError('Falha ao fazer login com Apple. Tente novamente.');
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5'
      }}
    >
      <Paper elevation={3} sx={{ p: 4, width: 400, maxWidth: '90%', textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom sx={{ color: '#2D2A26' }}>
          Barba Admin
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Acesse o painel administrativo
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {loading ? (
          <Box sx={{ py: 3 }}>
            <CircularProgress sx={{ color: '#E89051' }} />
            <Typography variant="body2" sx={{ mt: 2, color: '#666' }}>
              Verificando acesso...
            </Typography>
          </Box>
        ) : (
          <>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
              <AppleLogin
                clientId={process.env.REACT_APP_APPLE_CLIENT_ID}
                redirectURI={process.env.REACT_APP_APPLE_REDIRECT_URI || window.location.origin}
                responseType="code id_token"
                responseMode="web_message"
                scope="name email"
                usePopup={true}
                callback={handleAppleSuccess}
                onError={handleAppleError}
                designProp={{
                  height: 44,
                  width: 280,
                  color: 'black',
                  border_radius: 12,
                  type: 'sign-in',
                  locale: 'pt_BR'
                }}
              />
            </Box>
          </>
        )}
      </Paper>
    </Box>
  );
}

export default LoginPage;
